module.exports = __webpack_public_path__ + "img/Share-08.c034c069.svg";